module.exports = __webpack_public_path__ + "img/3oWlJ8M85DdOP-2jjDfObl.d5223fe7.png";